import React, { FC } from 'react';
import { usePrintTool } from '../hooks';
import { Printer } from 'react-feather';


const PrintTool: FC = () => {
  const {
    title,
    author,
    copyrightText,
    format,
    layout,
    scaleBarUnit,
    printInProgress,
    actions: { printMap, setAuthor, setFormat, setCopyrightText, setLayout, setScaleBarUnit, setTitle },
  } = usePrintTool()

  return (
    <div className="container">
      <input type="text" className="block-input" placeholder="Map Title" value={title} onChange={setTitle} />
      <input type="text" className="block-input" placeholder="Author" value={author} onChange={setAuthor} />
      <input type="text" className="block-input" placeholder="Copyright Text" value={copyrightText} onChange={setCopyrightText} />
      <div className="horiz-input-group">
        <label htmlFor="ddFormat">Format:</label>
        <select id="ddFormat" value={format} onChange={setFormat}>
          <option value="pdf">PDF</option>
          <option value="png32">PNG32</option>
          <option value="png8">PNG8</option>
          <option value="jpg">JPEG</option>
          <option value="gif">GIF</option>
          <option value="eps">EPS</option>
          <option value="svg">SVG</option>
          <option value="svgz">SVGZ</option>
        </select>
      </div>
      <div className="horiz-input-group">
        <label htmlFor="ddLayout">Layout:</label>
        <select id="ddLayout" value={layout} onChange={setLayout}>
          <option value="map-only">Map Only</option>
          <option value="a3-landscape">A3 Landscape</option>
          <option value="a3-portrait">A3 Portrait</option>
          <option value="a4-landscape">A4 Landscape</option>
          <option value="a4-portrait">A4 Portrait</option>
          <option value="letter-ansi-a-landscape">Letter ANSI A Landscape</option>
          <option value="letter-ansi-a-portrait">Letter ANSI A Portrait</option>
          <option value="tabloid-ansi-b-landscape">Tabloid ANSI B Landscape</option>
          <option value="tabloid-ansi-b-portrait">Tabloid ANSI B Portrait</option>
        </select>
      </div>
      <div className="horiz-input-group">
        <label htmlFor="ddScaleUnit">Unit:</label>
        <select id="ddScaleUnit" value={scaleBarUnit} onChange={setScaleBarUnit}>
          <option value="Miles">Miles</option>
          <option value="Kilometers">Kilometers</option>
          <option value="Meters">Meters</option>
          <option value="Feet">Feet</option>
        </select>
      </div>
      {printInProgress
        ? (<span className="btn-outline active"><i style={{marginRight: ".5rem"}} className="fa fa-spinner fa-spin"></i> Generating Map...</span>)
        : (<span className="btn-outline active" onClick={printMap}><Printer />Print</span>)
      }
    </div>
  )
}

export default PrintTool